import { render, staticRenderFns } from "./CommonUploadOtherBanks.vue?vue&type=template&id=d4b58f3a&scoped=true"
import script from "./CommonUploadOtherBanks.vue?vue&type=script&lang=js"
export * from "./CommonUploadOtherBanks.vue?vue&type=script&lang=js"
import style0 from "./CommonUploadOtherBanks.vue?vue&type=style&index=0&id=d4b58f3a&prod&scoped=true&lang=css"
import style1 from "./CommonUploadOtherBanks.vue?vue&type=style&index=1&id=d4b58f3a&prod&lang=css"
import style2 from "./CommonUploadOtherBanks.vue?vue&type=style&index=2&id=d4b58f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b58f3a",
  null
  
)

export default component.exports